module.exports = __webpack_public_path__ + "img/map-SWEDEN-en.c2b6036c.webp";